import {
  CampaignConfigDto,
  DiscountDto,
} from '@coretava/api/ecommerce-service';
import { UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { Trans } from '@gamiphy/react-i18n';
import { getDiffInDays } from '@gamiphy/utils/date';
import { Button, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import { formatCampaignReward, formatDiscountValue } from '../../utils';

type Props = {
  campaign: CampaignConfigDto,
  discount?: DiscountDto
}

const NonBogoCampaign: React.FC<Props> = ({ campaign, discount }) => {
  const rewardValues = React.useMemo(() => ({
    discountValue: discount ? formatDiscountValue(discount) : formatCampaignReward(campaign),
    validity: discount?.expiresAt ? getDiffInDays(new Date(discount.expiresAt), new Date())
      : campaign.rewardConfig?.validFor,
    minRedemptionAmount: discount?.cashbackConfig.minRedemptionValue ?? 100 * ((campaign.rewardConfig?.value ?? 0) / (campaign.rewardConfig?.multiplier ?? 1)),

  }), [discount, campaign]);

  return (
    <>

      <Typography fontSize={14} mb={2}>
        <Trans
          i18nKey="campaigns.boosters.basic.gift.details"
          defaults="Receive a <strong>{{discountValue}} discount</strong> on your next order over {{minRedemptionAmount, currency}}! Offer valid for {{validity}} days. Don't miss out!"
          values={{ ...rewardValues }}
        />
      </Typography>
      <Button variant="contained" onClick={() => UiStore.close()} fullWidth>
        <Trans
          i18nKey="coreloyalty.cashback.shopNow"
          defaults="Shop now"
        />
      </Button>
    </>
  );
};

export default observer(NonBogoCampaign);
